document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  const ids = window.SINGLE_PRODUCT_VARIANTS || [];
  const input = form.querySelector('[name="id"]');
  const variantId = input ? Number(input.value) : null;

  // jiný produkt → nech téma dělat, co normálně dělá
  if (!variantId || !ids.includes(variantId)) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  await fetch('/cart/clear.js', { method: 'POST' });
  await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
  window.location.href = '/checkout';
}, true);